export default "https://assets.egbcdn.net/assets/packs/_/images/user-promotions-promo/x2-bets-076998bae3aa640c2a205abf07051213.png";